export const BUSINESS_COVER_RATIO = 16 / 9;

export const BUSINESS_COVER_WIDTH = 464;

export const DEFAULT_COVER_ID = 'dddf12611932402ea12659064926f94f';
